interface EmailPayload {
  to: string;
  subject: string;
  title: string;
  body: string;
  from?: string;
}

const EMAIL_API_ENDPOINT = 'https://61orphbqm4.execute-api.us-east-1.amazonaws.com/prod/email';

export async function sendEmail(payload: EmailPayload): Promise<void> {
  try {
    const response = await fetch(EMAIL_API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to: payload.to,
        subject: payload.subject,
        title: payload.title,
        body: payload.body,
        from: payload.from || 'noreply@devopskiwi.com',
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Optional: handle response if needed
    const result = await response.json();
    console.log('Email sent successfully:', result);
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
}

export { type EmailPayload };
